import {calculateAge, getMBAPremium} from "../../shared";

const {createObject, createString, traversePropertiesString, traversePropertiesArray} = require('../../shared');

module.exports.coverage = function (appData, formData, outData, formDataKey) {

  //TODO: Inquire on replace Existing Coverage with Travis
  if (!outData.error && !createObject(appData, "coverage", {readMaterials: true, replaceExistingCoverage: false})) {
    outData.error = "Cannot create coverage info";
  }


  if (!outData.error && !createString(appData.coverage, "coverage", traversePropertiesString(formData, ['coverages', (formDataKey === "spouse" ? "mbaSpouseCoverage" : 'mbaCoverage')]), true)) {
    outData.error = "Missing MBA coverage amount";
  }

  if (!outData.error && appData.coverage.coverage === "50000" && traversePropertiesArray(formData,['dependents']).length > 0) {
    outData.error = "You must have coverage of $100,000 or more with dependents";
  }
  const premium = getMBAPremium(calculateAge(traversePropertiesString(formData, [(formDataKey === "spouse" ? "spouse" : 'primary'),'bdate'])), traversePropertiesString(formData, [(formDataKey === "spouse" ? "spouse" : 'primary'),'tobacco']) === "Y", traversePropertiesString(formData, ['coverages', (formDataKey === "spouse" ? "mbaSpouseCoverage" : 'mbaCoverage')]));
  if (!outData.error && !createString(appData.coverage, "premium", premium, true)){
    outData.error = "Unable to calculate premium";
  }

};


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/MBA/coverage.js